import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Loader2, CheckCircle, XCircle } from 'lucide-react';
import axios from 'axios';

const API = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '');

const MagicLogin = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const verifyMagicLink = async () => {
      const token = searchParams.get('token');
      
      if (!token) {
        setStatus('error');
        setErrorMessage('Kein Token gefunden');
        return;
      }

      try {
        // Use reusable magic link endpoint
        const response = await axios.get(`${API}/api/admin/verify-magic-link?token=${token}`);
        
        if (response.data.token) {
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('user', JSON.stringify(response.data.user));
          
          setStatus('success');
          
          const redirectPath = response.data.redirect_path || '/app/kreation';
          setTimeout(() => {
            window.location.href = redirectPath;
          }, 1000);
        }
      } catch (error) {
        setStatus('error');
        setErrorMessage(
          error.response?.data?.detail || 
          'Magic Link ist ungültig oder abgelaufen'
        );
      }
    };

    verifyMagicLink();
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-[#0A1628] flex items-center justify-center">
      <div className="bg-[#1A2B42] p-8 rounded-lg shadow-xl max-w-md w-full mx-4 text-center">
        {status === 'verifying' && (
          <>
            <Loader2 className="w-16 h-16 text-[#00D9C8] animate-spin mx-auto mb-4" data-testid="magic-link-loading" />
            <h1 className="text-xl font-bold text-white mb-2">
              Magic Link wird überprüft...
            </h1>
            <p className="text-[#A0AEC0]">
              Bitte warten Sie einen Moment
            </p>
          </>
        )}

        {status === 'success' && (
          <>
            <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" data-testid="magic-link-success" />
            <h1 className="text-xl font-bold text-white mb-2">
              Erfolgreich angemeldet!
            </h1>
            <p className="text-[#A0AEC0]">
              Sie werden weitergeleitet...
            </p>
          </>
        )}

        {status === 'error' && (
          <>
            <XCircle className="w-16 h-16 text-red-500 mx-auto mb-4" data-testid="magic-link-error" />
            <h1 className="text-xl font-bold text-white mb-2">
              Anmeldung fehlgeschlagen
            </h1>
            <p className="text-[#A0AEC0] mb-4">
              {errorMessage}
            </p>
            <a 
              href="/login"
              className="inline-block bg-[#00D9C8] text-[#0A1628] px-6 py-2 rounded font-medium hover:bg-[#00D9C8]/90 transition-colors"
              data-testid="magic-link-login-fallback"
            >
              Zur Login-Seite
            </a>
          </>
        )}
      </div>
    </div>
  );
};

export default MagicLogin;
